import {
    CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST,
    CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS,
    CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE,
    DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST,
    DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS,
    DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE,
    FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE,
    UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST,
    UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS,
    UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE,
    RESET_ALL_OVER_PRINTING_DC_INWARD_DETAILS_INFO,
    CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FORM,
    UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FORM,
    FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_PREVIOUS_ALL_OVER_PRINTING_INWARD_DETAILS_REQUEST,
    FETCH_PREVIOUS_ALL_OVER_PRINTING_INWARD_DETAILS_SUCCESS,
    ALL_OVER_PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED
} from './printingDcInwardDetails.actionsType';

export const ALL_OVER_PRINTING_DC_INWARD_DETAILS = 'allOverPrintingDcInwardDetails';

let initialState = {
    loading: false,
    printingDcInwardDetails: [],
    isDisabledDC: false,
    printingDcInwardDetailsWithoutId: [],
    previousGetList: [],
    printingDcInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0
    },
    selectedState: {},
    errorMessage: ''
};

export let allOverPrintingDcInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST:
        case FETCH_PREVIOUS_ALL_OVER_PRINTING_INWARD_DETAILS_REQUEST:
        case CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST:
        case UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST:
        case DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardDetails: updatePayload
            };
        case FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsWithoutId: updatePayload
            };
        case FETCH_PREVIOUS_ALL_OVER_PRINTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.PRII
            };
        case CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false
            };
        case UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false
            };
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: updatePayload
            };
        case DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false
            };
        case RESET_ALL_OVER_PRINTING_DC_INWARD_DETAILS_INFO:
            return {
                ...state,
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false
            };
        case CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FORM:
        case UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: {
                    ...state.printingDcInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case ALL_OVER_PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED:
            return {
                ...state,
                isDisabledDC: payload
            };
        case FETCH_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE:
        case FETCH_PREVIOUS_ALL_OVER_PRINTING_INWARD_DETAILS_REQUEST:
        case CREATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE:
        case UPDATE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE:
        case DELETE_ALL_OVER_PRINTING_DC_INWARD_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
